// extracted by mini-css-extract-plugin
export default {"container":"explainer_container__YAb7t","description":"explainer_description__x4qhg","link":"explainer_link__i4uk0"};